export default {
  StartupMessage__CLOSE_BUTTON_ARIA: "Click close button to dismiss modal message.",
  StartupMessage__ERROR_DEFAULT_TEXT:
    "We are unable to process your request. Please try again. If you continue to have difficulties, please contact a Southwest Airlines® Customer Representative at 1-800-I-FLY-SWA (1-800-435-9792).",
  StartupMessage__ERROR_DEFAULT_TITLE: "Sorry, we found some errors...",
};
